import { Heart } from "lucide-react";
import { useUserAuth } from "@/context/UserAuthContext";

/**
 * Heart toggle to favorite a program (Google-signed-in users).
 * Stops click propagation so it can sit inside cards/links.
 */
export default function FavoriteButton({ slug, className = "" }) {
  const { favorites, toggleFavorite } = useUserAuth();
  const active = favorites.includes(slug);

  return (
    <button
      type="button"
      aria-label={active ? "Remove from my programs" : "Save to my programs"}
      aria-pressed={active}
      data-testid={`favorite-btn-${slug}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(slug);
      }}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full border-2 transition-all duration-200 ${
        active
          ? "bg-berry border-berry text-white scale-105"
          : "bg-white/90 border-ink/15 text-ink/60 hover:border-berry hover:text-berry"
      } ${className}`}
    >
      <Heart size={16} fill={active ? "currentColor" : "none"} />
    </button>
  );
}
